import { toggleMark } from "prosemirror-commands";
import { EditorState, Transaction } from "prosemirror-state";
import { Node } from "prosemirror-model";
import { MarkKeys } from "./Schema";

function markActiveFactory(markName: MarkKeys) {
	return function isActive(state: EditorState) {
		const { from, $from, to, empty } = state.selection;
		const mark = state.schema.marks[markName];
		if (empty) {
			return !!mark.isInSet(state.storedMarks || $from.marks());
		} else {
			return state.doc.rangeHasMark(from, to, mark);
		}
	};
}

export const strongActive = markActiveFactory("strong");
export const emActive = markActiveFactory("em");
export const uActive = markActiveFactory("u");
export const subActive = markActiveFactory("sub");
export const supActive = markActiveFactory("sup");

function toggleMarkFactory(markName: MarkKeys) {
	return function toggleMarkImpl(state: EditorState, dispatch?: (tx: Transaction) => void) {
		return toggleMark(state.schema.marks[markName])(state, dispatch);
	};
}

export const toggleStrong = toggleMarkFactory("strong");
export const toggleEm = toggleMarkFactory("em");
export const toggleU = toggleMarkFactory("u");
export const toggleSub = toggleMarkFactory("sub");
export const toggleSup = toggleMarkFactory("sup");

function rangeHasAnyMarks(from: number, to: number, node: Node) {
	let found = false;
	node.nodesBetween(from, to, n => {
		if (n.marks.length > 0) {
			found = true;
		}
		return !found;
	});
	return found;
}

export function isAnyMarkActive(state: EditorState) {
	const { from, $from, to, empty } = state.selection;
	if (empty) {
		return (state.storedMarks || $from.marks()).length > 0;
	} else {
		return rangeHasAnyMarks(from, to, state.doc);
	}
}

export function clearInlineFormatting(state: EditorState, dispatch?: (tx: Transaction) => void) {
	const { from, to } = state.selection;
	const did = isAnyMarkActive(state);

	if (dispatch && did) {
		dispatch(state.tr.setStoredMarks([]).removeMark(from, to));
	}

	return did;
}
